import {
  SHELL_INVEST_TAB_INDEX,
  isInvestTabInShellPath,
} from "@utils/bridge/shellTabPathPolicy";
import { getBridge, isUnifiedNativeMainShell } from "@/src/lib/bridge";

import { ROUTER_PATH } from "@/src/config";
import { appTypes } from "@/src/config/seo";
import { isValidLocale } from "@/src/utils/i18n.locale";
import { normalizePathname } from "@/src/utils/routeNormalizer";

/** Preserve locale / device prefix from current URL and build Invest path. */
const buildInvestHref = (): string => {
  const segments = window.location.pathname.split("/").filter(Boolean);
  const prefix: string[] = [];
  let index = 0;

  if (segments[0] && isValidLocale(segments[0])) {
    prefix.push(segments[0]);
    index = 1;
  }
  if (index < segments.length && appTypes.includes(segments[index])) {
    prefix.push(segments[index]);
  }

  const investPath = normalizePathname(ROUTER_PATH.INVEST);
  return prefix.length > 0 ? `/${prefix.join("/")}${investPath}` : investPath;
};

/**
 * Onboarding Welcome CTA: close only when already on Invest shell path; otherwise navigate to Invest.
 */
export const navigateToInvestFromOnboardingWelcome = (): void => {
  if (typeof window === "undefined") {
    return;
  }

  const pathname = normalizePathname(window.location.pathname);
  if (isInvestTabInShellPath(pathname)) {
    return;
  }

  if (getBridge().isInApp()) {
    if (isUnifiedNativeMainShell()) {
      window.location.assign(buildInvestHref());
      return;
    }
    getBridge().switchShellTab(SHELL_INVEST_TAB_INDEX);
    return;
  }

  window.location.assign(buildInvestHref());
};
